<template>

    <v-dialog

      v-model="dialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn elevation="2" small color="info" class="ml-1 my-2 my-md-0" v-bind="attrs" v-on="on" @click="btnEntrada">
            <v-icon>mdi-car-info</v-icon> Entrar a taller
          </v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="warning">
          <v-btn icon dark @click="cerrarDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Entrada a servicio</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="imprimir"
              v-show="this.pagina==2"
            > <v-icon class="mr-2">mdi-printer</v-icon>
              Imprimir
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container v-show="this.pagina==1">
          <v-row>
            <v-col>
              <div class="d-flex flex-column justify-center align-center" style="height: 80vh">
                <h3>¿El vehículo de {{item.client.name}} entrará a Servicio?</h3>
                <div class="d-flex flex-row mt-5">
                  <v-btn color="red" dark @click="cancelar()">No</v-btn>
                  <v-btn color="success" @click="pagina=2" class="ml-3">Si</v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-show="this.pagina==2">
          <div id="contrato">
            <p>
              Firma de <b>cliente</b>: <br>
            </p>

          </div>
           <div class="sign">
            <el-dialog title="Firma en línea" :visible.sync="visible" :show-close="false">
              <sign-canvas
                class="sign-canvas"
                ref="SignCanvas"
                :options="options"
                v-model="value"
                @change="handleReceiverSign"
              />
              <div class="btnList">
                <v-btn
                  color="error"
                  size="small"
                  fab
                  dark
                  class=""
                  @click="canvasClear()"
                  ><v-icon>mdi-pen-off</v-icon></v-btn>
              </div>
            </el-dialog>
          </div>
          <img v-if="value" :src="value" width="180" height="160" />
        </v-container>
      </v-card>
    </v-dialog>


</template>
<script>
import ApiService from "../../services/apis";
import SignCanvas from "sign-canvas";
export default {
  name: "Contrato",
  data() {
    return {
      value:null,
      options: {
        lastWriteSpeed: 1, // Velocidad de escritura [Número] opcional
        lastWriteWidth: 2, // El ancho de la pluma [Número] opcional
        lineCap: "round", // El tipo de borde de la línea [tope] borde recto [redondo] tapa de línea redonda [cuadrado] tapa de línea cuadrada
        lineJoin: "round", // Tipos de esquinas cuando las líneas se cruzan [bisel] Crear biseles [redondo] Crear esquinas redondeadas [inglete] Crear esquinas afiladas.
        canvasWidth: 700, // ancho y altura del lienzo [Número] opcional
        canvasHeight: 450, // Altura [Número] opcional
        isShowBorder: false, // Si se muestra el borde [opcional]
        bgColor: "#fafafa", // Color de fondo [Cadena] opcional
        borderWidth: 1, // Ancho de línea de la cuadrícula [Número] opcional
        borderColor: "#ff787f", // Color de cuadrícula [String] opcional
        writeWidth: 5, // Ancho de pista base [Número] opcional
        maxWriteWidth: 30, // Ancho máximo de línea en modo de escritura [Número] opcional
        minWriteWidth: 5, // Ancho mínimo de línea en modo de escritura [Número] opcional
        writeColor: "#101010", // Color de pista [Cadena] opcional
        isSign: true, // Modo de firma [Boolean] El valor predeterminado es el modo sin firma, wireframe, cuando se establece en true no hay wireframe
        imgType: "png" // Formato de imagen descargada [Cadena] opcional ya que el lienzo jpeg es originalmente un fondo transparente
      },
      base64:null
    };
  },
  props:{
    item:null,
    pagina:null
  },
  components:{
    SignCanvas
  },
  watch: {
      menu (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
    },
    created(){
      var moment = require('moment')
      moment.locale('es')
      this.hoy=moment().format('L');

    },
    methods: {
      /**
           * Mesa de trabajo clara
     */
      canvasClear() {
        this.$refs.SignCanvas.canvasClear();
      },

      /**
             * guardar foto
       */
      saveAsImg() {
        const img = this.$refs.SignCanvas.saveAsImg();
        // alert (base64 de `image: $ {img}`);
        this.base64=img
        this.$emit("update:visible", false);
      },

      /**
             * Descargar fotos
       */
      downloadSignImg() {
        this.$refs.SignCanvas.downloadSignImg();
      },
      Entrada(){
        ApiService.ordenEditar(this.item._id, {status: 2}).then(() => {
          this.pagina=2

        });
      },
      cancelar(){
        //this.dialog=false
        window.location.reload()
        //this.$forceUpdate()
      },
      btnEntrada(){
        this.pagina=1
      },
      cerrarDialog(){
        this.dialog = false
        this.$forceUpdate()
      },
      imprimir() {
        let imprimir = "";
        imprimir = document.getElementById("ticketSalida");
        var ventana = "";
        ventana = window.open("", "PRINT", "height=400,width=600");
        ventana.document.write(
          "<html><head><title></title>"
        );
        ventana.document.write('<link rel="stylesheet" href="./estilos.css">');
        ventana.document.write("</head><body >");
        ventana.document.write(imprimir.innerHTML);
        ventana.document.write("</body></html>");
        ventana.document.close();
        ventana.focus();
        setTimeout(() => {
          ventana.print();
          window.location.reload()
        }, 2000);
      },

    },
};
</script>
<style  scoped>
.sign > .el-dialog{
    background: #b4a078;
}
.sign > .el-dialog__header {
    padding: 2px 0px
}

.sign> .el-dialog__body {
    padding:0em 0
}
.sign > .el-button{
    /*font-family STXingkai*/
    font-size: 12px;
    font-weight: 400
}
.btnList{
    padding: 5px
}
.sign > .el-dialog__title {
    line-height: 32px;
    font-size: 24px;
    /*font-family STXingkai*/
    color: hsl(40, 28.57% , 30.82%);
    text-shadow: 0 .03em .03em black;
 }
.sign-canvas {
    display: block;
    margin: 0 auto;
    background: #f4f0ea;
    border-radius: 8px;
}
</style>
